import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const SEARCH_USERS: DocumentNode = gql`
  query searchUsers($searchText: String!) {
    searchUsers(searchText: $searchText) {
      id
      displayName
      timezone
      screenName
      createdAt
      commentsCount
      firstName
      lastName
      profileImageId
      votesCount
      profileImageFile {
        id
        name
        url
        hash
        extension
        userId
      }
    }
  }
`;

export const SEARCH_USERGROUPS: DocumentNode = gql`
  query searchUsergroups($searchText: String!, $types: [UserGroupType!]!) {
    searchUsergroups(searchText: $searchText, types: $types) {
      id
      name
      type
    }
  }
`;
